'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const pascalCase = function () {
  let input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return input.split(/[^a-zA-Z0-9]/).map(s => s.toLowerCase()).map(s => (s[0] ?? '').toUpperCase() + s.substring(1)).join('');
};
const camelCase = function () {
  let input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const s = pascalCase(input);
  return (s[0] ?? '').toLowerCase() + s.substring(1);
};

exports.camelCase = camelCase;
exports.pascalCase = pascalCase;
